module.exports = __webpack_public_path__ + "img/fl.2b9ca829.png";